import { Modal } from 'antd';
import { t } from '../../i18n/i18n';
import './CryptoWarningDialog.scss';

const icon = (name) => ({ '--icon': `url(/icons/${name}.svg)` });

// What the processor's automation can match — anything else isn't delivered.
const COINS = ['ETH', 'USDC', 'USDT'];
const NETWORKS = [
  ['ERC20', 'Ethereum network'],
  ['TRC20', 'TRON network'],
];

/**
 * Shown when the trader picks CoinPayments. The processor's automation only
 * matches the listed coins on the listed networks, so the method is selected
 * only once the trader proceeds past this warning.
 */
export default function CryptoWarningDialog({ open, onCancel, onProceed }) {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={520}
      destroyOnHidden
      className="crypto-dialog"
      // Shares the Purchase Review dialog's antd shell overrides (mask, surface, close).
      rootClassName="pr-dialog-root"
      aria-label={t('Crypto payment warning')}
    >
      <div className="crypto-dialog__body">
        <header className="crypto-dialog__head">
          <span className="crypto-dialog__badge" aria-hidden="true">
            <span className="crypto-dialog__badge-icon" style={icon('warning-triangle')} />
          </span>
          <div className="crypto-dialog__heading">
            <h2 className="crypto-dialog__title">{t('Crypto Payment Warning')}</h2>
            <p className="crypto-dialog__lead">{t('You are proceeding with a cryptocurrency payment.')}</p>
          </div>
        </header>

        <section className="crypto-dialog__panel" aria-label={t('Accepted coins and networks')}>
          <p className="crypto-dialog__intro">
            {t('Please ensure that the correct coin is sent on the correct network.')}
          </p>
          <dl className="crypto-dialog__rows">
            <div className="crypto-dialog__row">
              <dt className="crypto-dialog__label">{t('Coin')}</dt>
              <dd className="crypto-dialog__chips">
                {COINS.map((coin) => (
                  <span key={coin} className="crypto-dialog__chip">
                    {coin}
                  </span>
                ))}
              </dd>
            </div>
            <div className="crypto-dialog__row">
              <dt className="crypto-dialog__label">{t('Network')}</dt>
              <dd className="crypto-dialog__chips">
                {NETWORKS.map(([code, name]) => (
                  <span key={code} className="crypto-dialog__chip">
                    {code}
                    <span className="crypto-dialog__chip-note">{t(name)}</span>
                  </span>
                ))}
              </dd>
            </div>
          </dl>
        </section>

        <p className="crypto-dialog__caution" role="note">
          {t(
            'Sending the wrong coin or using the wrong network will result in the automation not working and your account not being delivered, and funds may also be lost.',
          )}{' '}
          <strong>{t('Please proceed with caution.')}</strong>
        </p>

        <div className="crypto-dialog__actions">
          <button type="button" className="crypto-dialog__cancel" onClick={onCancel}>
            {t('Cancel')}
          </button>
          <button type="button" className="crypto-dialog__proceed" onClick={onProceed}>
            {t('Proceed')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
